import { useState as p } from "react";
import { create as E, test as i, enforce as s } from "vest";
import { useCreatePoiStore as d } from "./index.es137.js";
import { CREATE_POI_MIN_AREA_SIZE as P, CREATE_POI_MAX_AREA_SIZE as f } from "./index.es357.js";
const m = E((t) => {
  i("name", "Name is required", () => {
    s(t.name).isNotBlank();
  }), i("zip_code", "Zip Code is not valid", () => {
    t.zip_code && s(t.zip_code).matches("^\\d{5}(?:[-\\s]\\d{4})?$");
  }), i("sub_category", "sub_category is required", () => {
    s(t.category).isNotBlank();
  });
}), z = () => {
  const [t, n] = p({}), a = d(({ poiFields: e }) => e), o = d((e) => e.currentPolygonSize), _ = (e) => {
    const l = m(a);
    l.isValid(e) ? t[e] && n((r) => {
      const u = { ...r };
      return delete u[e], u;
    }) : n((r) => ({
      ...r,
      [e]: l.getMessage(e)
    }));
  }, g = (e) => {
    if (t[e])
      return [
        {
          state: "error",
          message: t[e]
        }
      ];
  };
  let c = !1;
  return o && (c = o >= P && o <= f), {
    updateValidation: _,
    errors: t,
    getFeedback: g,
    isValid: m(a).isValid() && c
  };
};
export {
  z as useCreatePoiValidation
};
//# sourceMappingURL=index.es138.js.map
